var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-meta__list-item-link",
      attrs: { href: "javascript:void(0)" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        }
      }
    },
    [
      _c("span", {
        staticClass: "nav-meta__list-item-text",
        domProps: { innerHTML: _vm._s(_vm.$t("reservation.iconLabel")) }
      }),
      _vm._v(" "),
      _c("SVGIndining", { staticClass: "nav-meta__list-item-icon" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }